import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];

  share(event) {
    event.preventDefault();
    event.stopPropagation();

    const site = event.target.dataset.site;
    const url = this.getUrl();
    const title = this.getTitle();
    const img = this.getImage();

    switch (site) {
      case "email":
        this.shareViaEmail(title, url);
        break;
      case "facebook":
        this.shareViaFacebook(url);
        break;
      case "linkedin":
        this.shareViaLinkedin(url, title);
        break;
      case "whatsapp":
        this.shareViaWhatsapp(url);
        break;
      case "link":
        this.copyToClipboard(url);
        break;
    }

    // Close the dropdown automatically after sharing
    const toggle = document.getElementById('shareDropdownToggle');
    if (toggle && toggle.parentElement) {
      toggle.parentElement.classList.toggle('dropdown-open');
    }
  }

  getTitle() {
    return encodeURIComponent(this.element.getAttribute("data-title") || '');
  }

  getImage() {
    return encodeURIComponent(this.element.getAttribute("data-img") || '');
  }

  getUrl() {
    let url = encodeURIComponent(this.element.getAttribute("data-url") || '');
    if (url.length === 0) {
      url = encodeURIComponent(window.location.href);
    }
    return url;
  }

  shareViaEmail(title, url) {
    const mailtoLink = `mailto:?subject=${title}&body=${url}`;
    window.location.href = mailtoLink;
  }

  shareViaFacebook(url) {
    const facebookUrl = `http://www.facebook.com/sharer/sharer.php?u=${url}`;
    window.location.href = facebookUrl;
  }

  shareViaLinkedin(url, title) {
    const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`;
    window.location.href = linkedinUrl;
  }

  shareViaWhatsapp(url) {
    const whatsappUrl = `https://api.whatsapp.com/send?text=${url}`;
    window.location.href = whatsappUrl;
  }

  copyToClipboard(url) {
    const copyText = document.createElement("textarea");
    copyText.value = decodeURIComponent(url);
    document.body.appendChild(copyText);
    copyText.select();
    document.execCommand("copy");
    document.body.removeChild(copyText);
    this.showCopiedMessage();
  }

  showCopiedMessage() {
    const copiedMessage = document.querySelector('.copied-message');
    copiedMessage.style.display = 'block';

    copiedMessage.classList.remove('translate-y-full');
    copiedMessage.classList.add('translate-y-0');

    setTimeout(() => {
      copiedMessage.style.display = 'none';
    }, 3000);
  }
}
